<template>
  <transition name="fade">
    <button
      v-if="visible"
      class="fixed bottom-6 right-6 z-40 h-11 w-11 rounded-full bg-primary-500 text-white shadow-primary-hover flex items-center justify-center hover:bg-primary-600 transition-colors"
      title="Volver arriba"
      @click="scrollToTop"
    >
      <svg
        class="w-5 h-5"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
      </svg>
    </button>
  </transition>
</template>

<script>
export default {
  name: "ScrollTopButton",

  props: {
    // El contenedor que realmente scrollea (el layout del dashboard scrollea
    // un div interno, no window).
    target: { type: Object, default: null },
  },

  data() {
    return { visible: false };
  },

  watch: {
    target(el, old) {
      if (old) old.removeEventListener("scroll", this.onScroll);
      if (el) el.addEventListener("scroll", this.onScroll, { passive: true });
    },
  },

  mounted() {
    if (this.target) {
      this.target.addEventListener("scroll", this.onScroll, { passive: true });
    }
  },

  beforeUnmount() {
    if (this.target) {
      this.target.removeEventListener("scroll", this.onScroll);
    }
  },

  methods: {
    onScroll(event) {
      this.visible = event.target.scrollTop > 400;
    },

    // Animación propia con rAF: behavior:'smooth' falla silenciosamente en
    // este contenedor (scrollTo instantáneo sí funciona).
    scrollToTop() {
      const el = this.target;
      if (!el) return;

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        el.scrollTop = 0;
        return;
      }

      const start = el.scrollTop;
      const duration = 350;
      let startTime = null;
      let animated = false;

      const step = (timestamp) => {
        animated = true;
        if (startTime === null) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.scrollTop = start * (1 - eased);
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);

      // Si no llega ningún frame (pestaña sin render loop), subir directo.
      setTimeout(() => {
        if (!animated) el.scrollTop = 0;
      }, 120);
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
